import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import { Infocar, type Props as InfocarProps } from '../../Infocar';
import type { SectionProps } from './section';
const InfocarSection: FC<SectionProps & InfocarProps> = t0 => {
  const $ = _c(9);
  const {
    infocarData,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classnames(...classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== infocarData) {
    t4 = <Infocar infocarData={infocarData} />;
    $[4] = infocarData;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <section className={t3}>{t4}</section>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default InfocarSection;
export type { InfocarProps };